import SecurityConfig from "@/pages/SecurityConfig";

export default [
  {
    path: "security-configuration",
    name: "Role Security Configuration",
    component: SecurityConfig,
  },
];
